<template>
  <div class="class_list">
    <template v-if="isIndex">
      <div class="PlanBox">
        <ots-main-title></ots-main-title>
        <ots-refer
          class="mb20 class-box"
          :selectList="selectList"
          :request-form="selectForm"
          @search="search"
        />
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getPagePlan } from "@/http/modules/examSet/examBatch";
export default {
  name: "",
  data() {
    return {
      tableHeader: [
        {
          title: "考试批次",
          prop: "code",
        },
        {
          title: "批次名称",
          prop: "name",
        },
        {
          title: "考试类型",
          prop: "examTypeName"
        },
        {
          title: "考试批次状态",
          prop: "planStateName",
        },
        {
          title: "考场安排",
          type: "buttons",
          width: "260",
          btnList: [
            {
              title: "查看",
              click: this.look,
            },
          ],
        },
      ],
      selectList: [
        {
          title: "批次名称",
          type: "select",
          multiple: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
          width: 200,
        },
      ],
      selectForm: {
        planId: [],
        page: 1,
        size: 10,
      },
   
      pagination: {
        total: 0,
      },
      tableData: [],
    };
  },
  watch: {
    "selectForm.planId": function(val) {
      this.selectForm.page = 1
      this.getAllPlanFn();
    },
  },
  computed: {
    isIndex() {
      return this.$route.name == "classList";
    },
  },
  created() {
    this.getAllPlanFn();
    this.getAllPlanList();
  },
  methods: {
    look(row) {
      this.$router.push({
        path: "/classList/classSet",
        query: {
          id: row.id,
        },
      });
    },
    search(){
      this.selectForm.page = 1
      this.getAllPlanFn();
    },
    getAllPlanList() {
      let params = {
        publish: 1,
        state: 1,
      };
      getPagePlan(params).then((res) => {
        this.$set(this.selectList[0], "data", res.data);
      });
    },
    changeSize(num) {
      this.selectForm.size = num;
      this.getAllPlanFn();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getAllPlanFn();
    },
    async getAllPlanFn() {
      let params = Object.assign({}, this.selectForm, {
        publish: 1,
        planId: this.selectForm.planId.toString(),
      });
      const { data } = await getPagePlan(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
  },
};
</script>

<style scoped lang="less">
.class_list {
  .class-box {
    /deep/ .el-select .el-input__inner {
      width: 300px;
    }
    /deep/ .el-select {
      width: 300px;
    }
    /deep/ .el-form-item__content {
      width: 300px;
    }
  }
}
</style>
